import { render, staticRenderFns } from "./OnboardingReview.vue?vue&type=template&id=6c40571b&scoped=true&"
import script from "./OnboardingReview.vue?vue&type=script&lang=js&"
export * from "./OnboardingReview.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingReview.vue?vue&type=style&index=0&id=6c40571b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c40571b",
  null
  
)

export default component.exports